import moment from "moment";

import config from "@/App/config";
import { HttpClient } from "@/App/services";
import { ICase, ITag } from "@/Case/services";

export const CaseService = {
  findById(id: String) {
    return HttpClient.get({ path: `/twiageCases/${id}` }).then(({ data }) => data);
  },

  getUploadFile(caseId: String, uploadId: String) {
    return HttpClient.downloadFile({ path: `/media/twiage-cases/${caseId}/uploads/${uploadId}` }).then(
      ({ data }) => data
    );
  },

  async getCasePDF(caseId: string): Promise<string> {
    const timezone = new Date().toString().match(/([+-]\d+)\s/)?.[1];
    const encodedTimezone = timezone && encodeURIComponent(timezone);
    const { data } = await HttpClient.downloadFile({
      path: `/admin/v4/twiageCases/${caseId}/pdf?timezone=${encodedTimezone}`
    });
    return URL.createObjectURL(new Blob([data], { type: "application/pdf" }));
  },

  getMessages(id: String) {
    return HttpClient.get({
      path: `/notification/twiage-cases/${id}/chat-messages`,
      rewriteBaseUrlWith: config.API_URL
    }).then(({ data }) => data);
  },

  augmentData(twiageCase: ICase): ICase {
    const pti = {};
    if (twiageCase.patientInfo) {
      pti["data"] = "";
      twiageCase.patientInfo.map(row => {
        pti[row.key] = row.value;
        pti["data"] = pti["data"] + row.value + " ";
      });
    }
    const augmented = {
      ...twiageCase,
      emsUser: twiageCase.createdBy ? `${twiageCase.createdBy.firstName} ${twiageCase.createdBy.lastName}` : "",
      caseDate: formatDateTime(twiageCase.createdAt),
      createdAtTime: formatDateTime(twiageCase.createdAt),
      arrivedAtTime: formatDateTime(twiageCase.arrivedAt),
      closedAtTime: formatDateTime(twiageCase.closedAt || twiageCase.arrivedAt),
      pti: pti
    };
    if (twiageCase.tags) {
      augmented.tags = formatTags(twiageCase.tags);
    }
    return augmented;
  }
};

function formatDateTime(dateTime: string): string {
  return dateTime ? moment(dateTime).format("YYYY-MM-DD HH:mm:ss") : "";
}

function formatTags(tags: Array<ITag> | { [key: string]: Array<string> }): { [key: string]: Array<string> } {
  if (!Array.isArray(tags)) {
    return tags;
  }

  return tags.reduce((result: { [key: string]: Array<string> }, tag: ITag) => {
    result[tag.type] = result[tag.type] ? [...result[tag.type], tag.name] : [tag.name];

    return result;
  }, {});
}
